<template>
    <div>
        <ValidationObserver ref="personalInfoFormValidate">
            <h6>{{ $t('identity_information') }}</h6>
            <div class="border p-4 rounded-sm mb-3">
                <b-row>
                    <b-col cols="12" md="6" lg="4">
                        <b-form-group :label="$t('national_id')">
                            <ValidationProvider name="national_id" rules="required" v-slot="{ errors }">
                                <b-form-input v-model="formData.national_id"
                                              v-mask="'###########'"
                                              :state="errors[0] ? false : null" />
                                <div class="invalid-feedback d-block" v-if="errors[0]" v-html="errors[0]"></div>
                            </ValidationProvider>
                        </b-form-group>
                    </b-col>
                    <b-col cols="12" md="6" lg="4">
                        <b-form-group :label="$t('name')">
                            <ValidationProvider name="name" rules="required" v-slot="{ errors }">
                                <b-form-input v-model="formData.name"
                                              type="text"
                                              :state="errors[0] ? false : null"
                                />
                                <div class="invalid-feedback d-block" v-if="errors[0]" v-html="errors[0]"></div>
                            </ValidationProvider>
                        </b-form-group>
                    </b-col>
                    <b-col cols="12" md="6" lg="4">
                        <b-form-group :label="$t('surname')">
                            <ValidationProvider name="surname" rules="required" v-slot="{ errors }">
                                <b-form-input v-model="formData.surname"
                                              type="text"
                                              :state="errors[0] ? false : null"
                                             />
                                <div class="invalid-feedback d-block" v-if="errors[0]" v-html="errors[0]"></div>
                            </ValidationProvider>
                        </b-form-group>
                    </b-col>
                    <b-col cols="12" md="6" lg="4">
                        <ValidationProvider name="birthdate" rules="required" v-slot="{ errors }">
                            <b-form-group :label="$t('birthdate')">
                                <select-date v-model="formData.birthdate" :validationError="errors[0]"/>
                            </b-form-group>
                        </ValidationProvider>
                    </b-col>
                    <!--                    <b-col cols="12" md="6" lg="4">-->
                    <!--                        <ValidationProvider name="gender" rules="required" v-slot="{ errors }">-->
                    <!--                            <b-form-group :label="$t('gender')">-->
                    <!--                                <gender-selectbox v-model="localFormData.gender"-->
                    <!--                                                  :disabled="isReadOnly"-->
                    <!--                                                  :validateError="errors[0]" />-->
                    <!--                            </b-form-group>-->
                    <!--                        </ValidationProvider>-->
                    <!--                    </b-col>-->
                    <b-col cols="12" md="6" lg="4">
                        <b-form-group :label="$t('gsm_no')">
                            <ValidationProvider name="phone" rules="required" v-slot="{ errors }">
                                <b-form-input v-model="formData.phone"
                                              v-mask="'5## ### ## ##'"
                                              :state="errors[0] ? false : null" />
                                <div class="invalid-feedback d-block" v-if="errors[0]" v-html="errors[0]"></div>
                            </ValidationProvider>
                        </b-form-group>
                    </b-col>
                    <b-col cols="12" md="6" lg="4">
                        <b-form-group :label="$t('email')">
                            <ValidationProvider name="email" rules="required|email" v-slot="{ errors }">
                                <b-form-input v-model="formData.email"
                                              :state="errors[0] ? false : null" />
                                <div class="invalid-feedback d-block" v-if="errors[0]" v-html="errors[0]"></div>
                            </ValidationProvider>
                        </b-form-group>
                    </b-col>
                    <b-col cols="12" md="6" lg="4">
                        <ValidationProvider name="city" rules="required" v-slot="{ errors }">
                            <b-form-group :label="$t('city')">
                                <city-selectbox v-model="formData.city_id"
                                                :validateError="errors[0]" />
                            </b-form-group>
                        </ValidationProvider>
                    </b-col>

                    <b-col cols="12" md="6" lg="4">
                        <ValidationProvider name="district" rules="required" v-slot="{ errors }">
                            <b-form-group :label="$t('district')">
                                <district-outline-selectbox v-model="formData.district_id"
                                                            :city_id="formData.city_id"
                                                            :validateError="errors[0]" />
                            </b-form-group>
                        </ValidationProvider>
                    </b-col>
                    <b-col cols="12" md="6" lg="4">
                        <b-form-group :label="$t('father_name')">
                            <ValidationProvider name="father_name" rules="required" v-slot="{ errors }">
                                <b-form-input v-model="formData.father_name"
                                              :state="errors[0] ? false : null"
                                />
                                <div class="invalid-feedback d-block" v-if="errors[0]" v-html="errors[0]"></div>
                            </ValidationProvider>
                        </b-form-group>
                    </b-col>
                    <b-col cols="12" md="12" lg="12">
                        <ValidationProvider name="address" rules="required" v-slot="{ errors }">
                            <b-form-group :label="$t('address')">
                                <b-form-textarea v-model="formData.address" rows="3"
                                                 :state="errors[0] ? false : null" />
                                <div class="invalid-feedback d-block" v-if="errors[0]" v-html="errors[0]" />
                            </b-form-group>
                        </ValidationProvider>
                    </b-col>
                    <b-col cols="12" md="6" lg="4">
                        <b-form-group :label="$t('high_school_name')">
                            <ValidationProvider name="school_name" rules="required" v-slot="{ errors }">
                                <b-form-input v-model="formData.school"
                                              :state="errors[0] ? false : null" />
                                <div class="invalid-feedback d-block" v-if="errors[0]" v-html="errors[0]"></div>
                            </ValidationProvider>
                        </b-form-group>
                    </b-col>
                    <b-col cols="12" md="6" lg="4">
                        <ValidationProvider name="school_city_id" rules="required" v-slot="{ errors }">
                            <b-form-group :label="$t('school') + ' ' + $t('city')">
                                <city-selectbox v-model="formData.school_city_id"
                                                :validateError="errors[0]" />
                            </b-form-group>
                        </ValidationProvider>
                    </b-col>
                    <b-col cols="12" md="6" lg="4">
                        <ValidationProvider name="school_district_id" rules="required" v-slot="{ errors }">
                            <b-form-group :label="$t('school') + ' ' + $t('district')">
                                <district-outline-selectbox v-model="formData.school_district_id"
                                                            :city_id="formData.school_city_id"
                                                            :validateError="errors[0]" />
                            </b-form-group>
                        </ValidationProvider>
                    </b-col>
                    <b-col cols="12" md="6" lg="4">
                        <ValidationProvider name="class" rules="required" v-slot="{ errors }">
                            <b-form-group :label="$t('class')">
                                <ParameterSelectbox code="bisep_application.high_school_classes" :public="true" v-model="formData.class" :validateError="errors[0]"/>
                            </b-form-group>
                        </ValidationProvider>
                    </b-col>
                    <b-col cols="12" md="6" lg="8">
                        <b-form-group :label="$t('high_school_score')">
                            <ValidationProvider name="school_diploma_point" rules="required|dynamic_between:1,100" v-slot="{ errors }">
                                <b-form-input v-model="formData.graduation_average"
                                              type="number"

                                              :state="errors[0] ? false : null" />
                                <div class="invalid-feedback d-block" v-if="errors[0]" v-html="errors[0]"></div>
                                <b-form-text>{{ $t('high_school_score_info') }}</b-form-text>
                            </ValidationProvider>
                        </b-form-group>
                    </b-col>
                </b-row>
            </div>
            <div class="d-flex justify-content-center mt-3">
                <processing-button :processing="loading" variant="primary"
                                   :label="$t('save_and_go').toUpper()" @click="save"/>
            </div>
        </ValidationObserver>
    </div>
</template>

<script>
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import CitySelectbox from '@/components/interactive-fields/CitySelectbox'
import DistrictOutlineSelectbox from "@/components/interactive-fields/DistrictOutlineSelectbox"
import ProcessingButton from '@/components/elements/ProcessingButton'

export default {
    name: 'ApplicationInformationTab',
    components: {
        ValidationObserver,
        ValidationProvider,
        CitySelectbox,
        DistrictOutlineSelectbox,
        ProcessingButton
    },
    data() {
        return {
            formData:{
                national_id:null,
                phone:null,
                email:null,
                city_id:null,
                father_name:null,
                district_id:null,
                address:null,
                school:null,
                school_city_id:null,
                school_district_id:null
            },
            loading: false
        }
    },
    methods: {
        validate() {
            return this.$refs.personalInfoFormValidate.validate()
        },
        async save() {
            const isValid = await this.$refs.personalInfoFormValidate.validate();
            if (isValid) {
                this.$emit('nextTab',{
                    currentTab:1,
                    formData:this.formData
                })
            }
        }
    }
}
</script>
